@for (item of visibleItems(); track $index) {
  <ng-container [ngTemplateOutlet]="itemTemplate()" [ngTemplateOutletContext]="{ $implicit: item, index: $index }"></ng-container>
}

@if (canToggle()) {
  <button type="button" class="collapsible-toggle" [attr.aria-expanded]="expanded()" (click)="toggle()">
    <span class="collapsible-toggle__label">
      {{ (expanded() ? "data-platform.show-less" : "data-platform.show-more") | translate }}
    </span>
    @if (!expanded()) {
      <span class="collapsible-toggle__count">{{ hiddenCount() }}</span>
    }
    <mat-icon class="collapsible-toggle__chevron">{{ expanded() ? "expand_less" : "expand_more" }}</mat-icon>
  </button>
}
